
export default function firstCharToUpper(string) {
  if (string === 'kg') {
    return string
  }
  
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const convertAddThsndDivider = (value) => {
  if (!value) {
    return 0
  }

  const inputValue = value.toString().replace(/,/g, '')
  return Number(inputValue).toLocaleString('en-US');
}

export const formatNumberWithMk = (num) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'k';
  } else {
    return num.toString();
  }
};

export const formatNumberThsndAndDec = (value) => {
  const clean = value.toString().replace(/,/g, "");
  const regex = /^[0-9]*\.?[0-9]*$/;

  if (value && clean.match(regex)) {
    if (!value.toString().includes(".")) {
      return Number(clean).toLocaleString('en-US');
    } else if (value.toString().slice(-1) === '.') {
      return value
    } else {
      const parts = clean.split('.')
      let integerPart = Number(parts[0]).toLocaleString('en-US');
      const decimalPart = parts[1] ? '.' + parts[1] : '';

      return integerPart + decimalPart;
    }
  } else if (value === 0) {
    return '0'
  } else {
    return '';
  }
};

export const formatNumberMagnitude = (value) => {
  if (Math.abs(value) >= 1.0e+9) {
    return (Math.abs(value) / 1.0e+9).toFixed(2).replace(/\.?0+$/, '') + 'B';
  } else if (Math.abs(value) >= 1.0e+6) {
    return (Math.abs(value) / 1.0e+6).toFixed(2).replace(/\.?0+$/, '') + 'M';
  } else if (Math.abs(value) >= 1.0e+3) {
    return (Math.abs(value) / 1.0e+3).toFixed(2).replace(/\.?0+$/, '') + 'k';
  } else {
    return value.toString();
  }
}

export const makePlural = (word, count = 2) => {
  // Irregular plural forms
  const irregularPlurals = {
    ox: 'oxen',
    mouse: 'mice',
    goose: 'geese',
    child: 'children',
    person: 'people',
    phenomenon: 'phenomena',
    man: 'men',
    woman: 'women',
    foot: 'feet',
    tooth: 'teeth',
    criterion: 'criteria',
    nucleus: 'nuclei',
    process: 'processes',
    kg: 'kg',
    km: 'km',
    'm³': 'm³',
    'produced kg': 'produced kg',
    'stored kg': 'stored kg',
    box: 'boxes',
  };

  // Check if the word has an irregular plural form
  if (irregularPlurals.hasOwnProperty(word)) {
    return count === 1 ? word : irregularPlurals[word];
  }

  // Check if the word is already plural
  if (count !== 1) {
    if (Object.values(irregularPlurals).includes(word)) {
      return word; // Return as is if it matches an irregular plural
    }
    if (word.endsWith('s') && !word.endsWith('ss')) {
      return word; // Return as is if it ends with 's' (common plural form) but not 'ss'
    }

    // Pluralization rules
    if (word.endsWith('y') && !'aeiou'.includes(word[word.length - 2])) {
      // Replace 'y' with 'ies'
      return word.slice(0, -1) + 'ies';
    } else if (word.endsWith('x') || word.endsWith('ch') || word.endsWith('sh')) {
      // Add 'es' for words ending in 'x', 'ch', or 'sh'
      return word + 'es';
    } else {
      // Add 's' for general pluralization
      return word + 's';
    }
  }

  // If count is 1, return the singular word as is
  return word;
};

export function intToWord(number) {
  const numberWords = [
    "zero", "one", "two", "three", "four", 
    "five", "six", "seven", "eight", "nine"
  ];

  // Check if the number is between 0 and 9, otherwise return the number itself
  return number >= 0 && number <= 9 ? numberWords[number] : number.toString();
}